import { v as bvVar } from 'bv';

const DEFAULT_GAMES_SLUG = 'casino';

export const { slug = DEFAULT_GAMES_SLUG } = bvVar('casinoLobbies').find(
  ({ tag }) => tag === 'default',
) || {};

export const getGameInfoHref = ({ id, titleURL }) => (
  `/${slug}/games/${id}-${titleURL}`
);

export const getGameLaunchHref = (game) => (`${getGameInfoHref(game)}/launch`);
